import * as  React from 'react';
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {RequestData} from '@models/axios';
import {connect} from "react-redux";
import {fetchRequest} from "@actions/resources";


/**
 * This class checks if resources has not fetched yet, fetch Table
 * Get resources Table from store and inject it as a props to the component.
 * @param Component
 */
const resourceFetcherHoc = <P extends object>(Component: React.ComponentType<P>) =>{
  
  class ResourceFetcher extends React.Component<P> {
    
    constructor(props) {
      super(props);
    }
    
    state = {
      currentPage : 1,
      data        : [],
      count       : 0
    };
    
    componentDidMount(){
      const {is_fetched, fetchRequest} = this.props;
      if (!is_fetched) {
        fetchRequest({
          params: {
            offset: 0,
            count: 200}
        });
      }
    }
    
    render() {
      return (
        <Component  {...this.props as P}
                    data={this.props.data}/>
      )
    }
  }
  
  const mapStateToProps = ({ resources }) => {
    return {
      is_fetched: resources.is_fetched,
      data: resources.data
    };
  };
  
  const mapDispatchToProps = {
    fetchRequest
  };
  
  return connect(mapStateToProps, mapDispatchToProps)(ResourceFetcher);
};


export default resourceFetcherHoc;